import { useEffect, useState } from "react";



const useIsLandSpace = () => {
  const [isLandSpace, setLandSpace] = useState<boolean>(
    window.matchMedia("(orientation: landscape)").matches
  );

  window.matchMedia("(orientation: landscape)").addEventListener("change", function (e) {
    setLandSpace(e.matches)
  });

  return isLandSpace;
};

export default useIsLandSpace;